import { render, staticRenderFns } from "./CategoryResult.vue?vue&type=template&id=459be71d&scoped=true"
import script from "./CategoryResult.vue?vue&type=script&lang=js"
export * from "./CategoryResult.vue?vue&type=script&lang=js"
import style0 from "./CategoryResult.vue?vue&type=style&index=0&id=459be71d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459be71d",
  null
  
)

export default component.exports